import * as React from "react";
import moment from "moment";
import { Col, Row, Button } from "reactstrap";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { useAuth0 } from "../auth/react-auth0-wrapper";
import { getMakes, getModels, getPreparations } from "../api/vehicles";
import useDebounce from "../utils/debounceHook";
import { it } from "../utils/content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const VehicleManualEdit = ({ vehicle, errors, onChange }) => {

    const selectedSupplier =
        vehicle && vehicle.attributes
            ? vehicle.attributes.infocarSupplier
            : undefined;
    const selectedMake =
        vehicle && vehicle.attributes ? vehicle.attributes.infocarMake : undefined;
    const selectedModel =
        vehicle && vehicle.attributes ? vehicle.attributes.infocarModel : undefined;
    const debouncedSupplier = useDebounce(selectedSupplier, 500);
    const debouncedMake = useDebounce(selectedMake, 500);
    const debouncedModel = useDebounce(selectedModel, 500);
    const { domains } = useAuth0();
    const [makes, setMakes] = React.useState([]);
    const [models, setModels] = React.useState([]);
    const [preparations, setPreparations] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const getDDTextInEvent = e =>
        e.originalEvent && e.originalEvent.currentTarget
            ? e.originalEvent.currentTarget.innerText
            : e.value;

    React.useEffect(() => {
        loadMakes();
    }, []);

    React.useEffect(() => {
        if (debouncedSupplier && debouncedMake) {
            loadModels(debouncedSupplier, debouncedMake);
        }
    }, [debouncedSupplier, debouncedMake]);

    React.useEffect(() => {
        if (debouncedModel) {
            loadPreparations(debouncedModel);
        }
    }, [debouncedModel]);

    const onVehicleChange = (changedProps) => {
        const newVehicle = { ...vehicle, ...changedProps };
        onChange({
            value: newVehicle
        });
    };

    const onAttributesChange = changedProps => {
        const attributes = { ...(vehicle.attributes || {}), ...changedProps };
        const newVehicle = { ...vehicle, attributes };
        onChange({
            value: newVehicle
        });
    };

    async function loadMakes() {
        const makesList = await getMakes();
        setMakes(makesList);
    }

    async function loadModels(alimen, make) {
        const modelsList = await getModels(make, alimen || "0");

        setPreparations([]);
        setModels(modelsList);
    }

    async function loadPreparations(modello) {
        const modelsList = await getPreparations(modello);

        setPreparations(modelsList);
    }

    const attributes = vehicle.attributes || {};
    const attributesErrors = errors.agttributes || {};
    const { plate, registeredat, km, registration } = vehicle;

    return (
        <Row>
            <Col sm="6" xs="12">
                <div><strong className="mt-2">Targa</strong></div>
                <InputText
                    className={errors.plate ? "p-error" : ""}
                    value={plate || ""}
                    style={{ width: "100%" }}
                    onChange={e => onVehicleChange({ plate: e.target.value, registration: e.target.value })}
                />
            </Col>
            <Col sm="6" xs="12">
                <strong className="mt-2">Numero di telaio</strong>
                <InputText
                    className={attributesErrors.frame ? "p-error" : ""}
                    value={attributes.frame || ""}
                    style={{ width: "100%" }}
                    onChange={e => onAttributesChange({ frame: e.target.value })}
                />
            </Col>
            <Col sm="12" xs="12" md="12">
                <strong className="mt-2">Tipo veicolo</strong>
                <Dropdown
                    filter
                    filterBy="label"
                    id="vehicleType"
                    className={attributesErrors.type ? "p-error" : ""}
                    value={attributes.type || ""}
                    showClear={true}
                    style={{ width: "100%" }}
                    options={domains.vehicleTypes}
                    onChange={e => {
                        onAttributesChange({
                            type: e.value,
                            model: "",
                            infocarModel: "",
                            preparation: "",
                            make: "",
                            infocarMake: ""
                        });
                    }}
                />
            </Col>
            <Col sm="12" xs="12" md="12">
                <strong className="mt-2">Alimentazione</strong>
                <Dropdown
                    filter
                    filterBy="label"
                    id="codSupplier"
                    className={attributesErrors.infocarSupplier ? "p-error" : ""}
                    value={attributes.infocarSupplier || ""}
                    showClear={true}
                    style={{ width: "100%" }}
                    options={domains.alimentazione.filter(el => el.value !== "0")}
                    onChange={e => {
                        onAttributesChange({
                            infocarSupplier: e.value,
                            supplier: getDDTextInEvent(e),
                            model: "",
                            infocarModel: "",
                            preparation: ""
                        });
                    }}
                />
            </Col>
            <Col sm="12" xs="12" md="12">
                <strong className="mt-2">Marca</strong>
                <Dropdown
                    filter
                    editable
                    filterBy="label"
                    id="infocarMake"
                    disabled={
                        !attributes.supplier || Number(attributes.supplier) === 0 || !attributes.type
                    }
                    className={attributesErrors.infocarMake ? "p-error" : ""}
                    value={attributes.infocarMake || ""}
                    showClear={true}
                    style={{ width: "100%" }}
                    options={makes.map(el => ({
                        label: el.Descrizione,
                        value: el.CodiceMarca
                    }))}
                    onChange={e => {
                        onAttributesChange({
                            infocarMake: e.value,
                            make: getDDTextInEvent(e),
                            model: "",
                            infocarModel: "",
                            preparation: ""
                        });
                    }}
                />
            </Col>
            <Col sm="12" xs="12" md="12">
                <strong className="mt-2">Modello</strong>
                <Dropdown
                    filter
                    editable
                    filterBy="label"
                    id="infocarModel"
                    className={attributesErrors.infocarModel ? "p-error" : ""}
                    value={attributes.infocarModel || ""}
                    showClear={true}
                    style={{ width: "100%" }}
                    options={models.map(el => ({
                        label: el.Descrizione,
                        value: el.CodiceModello
                    }))}
                    onChange={e => {
                        onAttributesChange({
                            infocarModel: e.value,
                            model: getDDTextInEvent(e),
                            preparation: ""
                        });
                    }}
                />
            </Col>
            <Col sm="12" xs="12" md="12">
                <strong className="mt-2">Allestimento</strong>
                <Dropdown
                    filter
                    editable
                    filterBy="label"
                    id="ddpreparation"
                    className={attributesErrors.preparation ? "p-error" : ""}
                    value={attributes.preparation || ""}
                    showClear={true}
                    style={{ width: "100%" }}
                    options={preparations.map(el => ({
                        label: el.DescrizioneCompleta,
                        value: el.DescrizioneCompleta
                    }))}
                    onChange={e => {
                        onAttributesChange({
                            preparation: getDDTextInEvent(e)
                        });
                    }}
                />
            </Col>

            <Col sm="3" xs="12">
                <strong className="mt-2">Data immatricolazione</strong>
                <Calendar
                    locale={it}
                    monthNavigator={true}
                    yearNavigator={true}
                    showButtonBar={true}
                    style={{ width: "100%" }}
                    className={errors.registeredat ? "p-error" : ""}
                    yearRange="1900:2099"
                    value={
                        registeredat
                            ? moment(registeredat).toDate()
                            : ""
                    }
                    onChange={e => onVehicleChange({ registeredat: e.value })}
                    dateFormat="dd/mm/yy"
                    showIcon={true}
                />
            </Col>

            <Col sm="3" xs="12">
                <strong className="mt-2">Codice linea CAN</strong>
                <InputText
                    className={attributesErrors.canCode ? "p-error" : ""}
                    value={attributes.canCode || ""}
                    style={{ width: "100%" }}
                    onChange={e => onAttributesChange({ canCode: e.target.value })}
                />
            </Col>

            <Col sm="6" xs="12">
                <div><strong className="mt-2">Km</strong></div>
                <InputText
                    className={`mr-2 ${errors.km ? "p-error" : ""}`}
                    value={km || ""}
                    style={{ width: "60%" }}
                    keyfilter="pint"
                    onChange={e => onVehicleChange({ km: e.target.value })}
                />
                <Button
                    disabled={loading ? true : false}
                    color="info"
                    onClick={null}
                >
                    <FontAwesomeIcon
                        icon={loading ? "circle-notch" : "search"}
                        spin={loading}
                    />{" "}
                    Aggiorna Km
                </Button>
            </Col>

            <Col sm="12" xs="12">
                <strong className="mt-2">Note</strong>
                <InputText
                    className={attributesErrors.note ? "p-error" : ""}
                    value={attributes.note || ""}
                    style={{ width: "100%" }}
                    onChange={e => onAttributesChange({ note: e.target.value })}
                />
            </Col>

        </Row>
    );
};

export default VehicleManualEdit;
